import { Component, OnInit } from '@angular/core';
import { headersTables } from '@bl-constants/table-header.const';
import { StepperService } from '@core/stepper/stepper.service';
import { MessageToastService } from '@core/messages/message-toast.service';

@Component({
  selector: 'bid-update-action-plan',
  templateUrl: './update-action-plan.component.html',
  styleUrls: ['./update-action-plan.component.scss'],
})
export class UpdateActionPlanComponent implements OnInit {
  headerTUAP: object;
  analysisData: any;
  STEP2 = [
    { name: 'loadActionPlan', stepSelected: false },
    { name: 'updateActionPlan', stepSelected: true, disabled: false },
    { name: 'myActionPlan', stepSelected: false, disabled: false },
  ];

  constructor(
    private stepperService: StepperService,
    public messageToastService: MessageToastService,
  ) {
    this.analysisData = {
      id: '1',
      country: 'argentina',
      operationNumber: '12354',
      externalAuditor: 'abjh',
      initDate: '2020/01/01',
      endDate: '2020/12/31',
      projectName: 'Apoyo a la Integración de Honduras en el Mercado Eléctrico Regional',
      loanNumber: '3256/OC-AR',
      reviewDate: 'Yes',
      parameterLuca: 'LMS HO-L 1039',
      answerFms: '',
      notes: '',
      parameterFms: '',
      testResults: {
        item_id: '1',
        finding: `Error en el objeto de la resolución de apertura del concurso de méritos para selección de Interventoría.
          En nuestra revisión de contratos suscritos con recursos de Contrapartida, observamos que el contrato
          de interventoría 00...`,
        recommendation: `Se recomienda al Ente Gestor, realizar una correcta aplicación de la Ley 80, Ley 1150 y sus
          modificaciones donde se detalla paso a paso los requisitos establecidos para cada tipo de contratación,
          así mismo...`,
        actionsDE: `Como medida preventiva se implementará un control de revisión previo a la firma de `,
        responsable: `Responsible for Action 1`,
        estimatedID: '01/01/01',
        meansV: 'Pendint',
      },
      summary: '13m 8s',
    };
  }

  ngOnInit() {
    this.headerTUAP = headersTables.headerUpdateActionPlanTable;
    this.stepperService.setStepper(this.STEP2);
  }
}
